import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import OmitIfEmpty from "%/dynamic-component-editor/options/omit-if-empty";
import EmptyStateMode from "%/dynamic-component-editor/options/empty-state-mode";
import EmptyStateText from "%/dynamic-component-editor/options/empty-state-text";
import EmptyStateComponentId from "%/dynamic-component-editor/options/empty-state-component-id";

// What a feed shows when it has no rows: a line of text OR a component the
// author built — never both. FeedEmptyStateToolSet renders the mode toggle and
// only the setting it selects, so an author can never leave a value that is
// silently ignored.
export default class FeedEmptyStateOptions extends BaseOptionsBundle {

  optionTitle = "Empty State";
  static optionClassName = "i-feed-empty-state";
  inspectorToolGroup = "feedEmptyState";
  useInspectorLabel = false;
  static userInterfaceComponent = {
    component: inspectorTools.FEED_EMPTY_STATE_TOOL_SET,
  };

  constructor(values = {}) {
    super(values, [
      new OmitIfEmpty(),
      new EmptyStateMode(),
      // Relabelled for THIS section only (4th ctor arg = overrideLabel): the
      // section header already says "Empty State", and the option keeps its own
      // label on the ~28 feed elements that have no Empty State section.
      new EmptyStateText({ "default": "No results found." }, false, true, "Message"),
      new EmptyStateComponentId(),
    ]);
  }
}
